"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBlockNavigation = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const dialogs_1 = require("./dialogs");
const useBlockNavigation = ({ blockLevel = "browser", confirm, // use for app level block
onAppNavigate, }) => {
    const [blocked, setBlockNavigation] = (0, react_1.useState)(false);
    const confirmModal = (0, dialogs_1.useConfirm)();
    let blocker = (0, react_router_dom_1.useBlocker)(({ currentLocation, nextLocation }) => blocked && currentLocation.pathname !== nextLocation.pathname);
    (0, react_1.useEffect)(() => {
        if (blocker.state === "blocked") {
            (() => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                if (!blockLevel || blockLevel === "app") {
                    const res = yield confirmModal({
                        message: (_a = confirm === null || confirm === void 0 ? void 0 : confirm.message) !== null && _a !== void 0 ? _a : "保存されていない変更があります。本当に画面遷移しますか?",
                    });
                    if (res) {
                        yield (confirm === null || confirm === void 0 ? void 0 : confirm.callback());
                        blocker.proceed();
                        setBlockNavigation(false);
                    }
                    else {
                        blocker.reset();
                    }
                }
                else if (blockLevel === "browser") {
                    yield (onAppNavigate === null || onAppNavigate === void 0 ? void 0 : onAppNavigate());
                    blocker.proceed();
                    setBlockNavigation(false);
                }
            }))();
        }
    }, [blocker.state]);
    (0, react_1.useEffect)(() => {
        // Handle block browser actions reload, close
        const handleBeforeUnload = (event) => {
            event.preventDefault(); // This will trigger the confirmation dialog in modern browsers
            // assign a message to returnValue for older browsers
            event.returnValue =
                "保存されていない変更があります。本当に画面遷移しますか?";
        };
        if (blocked && (!blockLevel || blockLevel === "browser")) {
            window.addEventListener("beforeunload", handleBeforeUnload);
        }
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [blocked]);
    return { setBlockNavigation };
};
exports.useBlockNavigation = useBlockNavigation;
